
import { Component, Vue } from "vue-property-decorator";
import RectComponent from "@/components/Common/Rects/RectComponent.vue";
import DireccionDialogComponent from "@/components/Common/Dialogs/DireccionDialogComponent.vue";
import organigramaService from "@/services/organigrama.service";
import menuService from "@/services/menu.service";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";

@Component({
  components: {
    RectComponent,
    DireccionDialogComponent,
    MobileSectionStrip
  }
})
export default class Organigrama extends Vue {
  private mediaUrl = process.env.VUE_APP_MEDIA_URL;
  public showDialog = false;
  public dialogInfo: any = {};
  public organigrama: any = {};
  public selectedDireccion: any = {};
  private menu: any = [];
  private menuLateral: any = [];

  private async mounted() {
    await this.getOrganigrama();
    await this.setMenu();
  }
  private async getOrganigrama() {
    try {
      const organigrama = await organigramaService.getOrganigrama();

      if (!organigrama) {
        throw {
          response: {
            data: {
              message: "No existe organigrama",
              code: 404
            }
          }
        };
      }
      this.organigrama = {
        id: organigrama.id,
        img: `${this.mediaUrl}${organigrama.img}`,
        banner_desktop: `${this.mediaUrl}${organigrama.banner_desktop}`,
        banner_mobile: `${this.mediaUrl}${organigrama.banner_mobile}`,
        direcciones: organigrama.direcciones.map((direccion: any) => ({
          ...direccion,
          img_responsible: direccion?.img_responsible
            ? `${this.mediaUrl}${direccion.img_responsible}`
            : null
        }))
      };
    } catch (err) {
      console.log(err);
    }
  }

  public openDialog(item: any) {
    this.selectedDireccion = item;
    this.showDialog = true;
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "organigrama-municipal")) {
        this.menuLateral = this.menu[i].sub_menu || [];
        break;
      }
    }
  }

  private getSubMenu(element: any, nombreWeb: string) {
    if (element.nombre_web == nombreWeb) return true;
    if (element.sub_menu && element.sub_menu.length > 0) {
      for (let i = 0; i < element.sub_menu.length; i++) {
        if (this.getSubMenu(element.sub_menu[i], nombreWeb)) return true;
      }
    }
    return false;
  }

  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }

  private toLink(url: any, blank: any) {
    if (url && url != "") {
      window.open(url, blank == 1 ? "_blank" : "_self");
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else if (nombreWeb == "organigrama-municipal") {
      this.routerGo("OrganigramaDos");
    } else if (nombreWeb == "boletin-municipal") {
      this.routerGo("Boletines");
    } else {
      this.$router.push({ name: "Pagina", params: { nombre: nombreWeb } });
    }
  }

  private routerGo(name: string) {
    if (this.$router.currentRoute.name == name) {
      this.$router.go(0);
    } else {
      this.$router.push({ name }).catch(err => console.log(err));
    }
  }
}
